import { FloorMapPresenter } from '@Map/FloorMap/FloorMapPresenter';
import type { MapLayout } from '@Model/MapModelsView';
import { useClassStore } from '@Utils/useClassStore';
import { inject, injectable } from 'inversify';
import { computed } from 'mobx';

import container from '~ioc/ioc';
import type { FloorStore } from '~stores/floor';
import { FloorsListStore } from '~stores/floors-list';

@injectable()
class MiniMap2Presenter {
  @inject(FloorsListStore) private _floorsStore2!: FloorsListStore;
  @inject(FloorMapPresenter) private _mapPresenter!: FloorMapPresenter;

  @computed get isFetching(): boolean {
    return Boolean(this.activeFloorStore?.isFetching.value);
  }

  @computed get layout(): MapLayout | undefined {
    return this.activeFloorStore?.content.value?.layout;
  }

  @computed get activeFloorStore(): FloorStore | undefined {
    return this!._floorsStore2.activeFloorStore;
  }

  @computed get showMapLayout(): boolean {
    return true; // TODO fix this when there's a static plan for floor maps
  }

  // TODO this now can be removed
  @computed get showShopFloor(): boolean {
    return false;
  }

  @computed get showError(): boolean {
    return false; // TODO fix this when there's a static plan for floor maps
  }

  onMapClick = () => {
    this._mapPresenter.setExtendedMapVisible(true);
  };
}

export const useMiniMap2Presenter = () =>
  useClassStore<MiniMap2Presenter>(container.get(MiniMap2Presenter));
